import { PlexRoute } from '@all-hands-hq/plex-graphql-schema';
import { SvgIconComponent } from '@material-ui/icons';
import assertNever from 'assert-never';
import React from 'react';

import { ReactComponent as PlexFaqLinkSvg } from '../assets/plex_faq_link.svg';
import { ReactComponent as PlexFileLinkSvg } from '../assets/plex_file_link.svg';
import { ReactComponent as PlexPostLinkSvg } from '../assets/plex_post_link.svg';
import { LinkPreviewMetadataFragment } from '../graphql/gen/types';

type LinkDataType = {
  title: string | undefined;
  subtitle: string;
  LinkIcon: SvgIconComponent | React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  plexContentLink: Partial<PlexRoute> | null;
};

export const getLinkData = (
  data: LinkPreviewMetadataFragment['details'] &
    (
      | { __typename: 'PlexPostLinkMetadata' }
      | { __typename: 'PlexFactLinkMetadata' }
      | { __typename: 'AttachmentLinkMetadata' }
      | { __typename: 'GoogleDocLinkMetadata' }
      | { __typename: 'GoogleDriveFileLinkMetadata' }
      | { __typename: 'GoogleSheetsLinkMetadata' }
      | { __typename: 'GoogleSlidesLinkMetadata' }
      | { __typename: 'GenericLink' }
      | { __typename: 'InvalidLink' }
    )
): LinkDataType => {
  let title: string | undefined;
  let subtitle: string;
  let LinkIcon: SvgIconComponent | React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  let plexContentLink: Partial<PlexRoute> | null = null;
  switch (data.__typename) {
    case 'PlexPostLinkMetadata':
      title = data.post?.title;
      subtitle = `Plex Post • ${data.post?.plex.name}`;
      if (data.post != null) {
        plexContentLink = { selectedItem: { type: 'post', permalink: data.post.permalink, commentsVisible: false } };
      }
      LinkIcon = PlexPostLinkSvg;
      break;
    case 'PlexFactLinkMetadata':
      title = data.fact?.text;
      subtitle = `Plex Fact • ${data.fact?.plex.name}`;
      if (data.fact != null) {
        plexContentLink = {
          selectedItem: { type: 'question', permalink: data.fact.permalink, commentsVisible: false },
        };
      }
      LinkIcon = PlexFaqLinkSvg;
      break;
    case 'AttachmentLinkMetadata':
      title = undefined;
      // TODO(https://github.com/all-hands-hq/source/issues/1268): file name / size
      subtitle = `Attachment • ${data.extension.toUpperCase()}`;
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'GoogleDocLinkMetadata':
      title = data.fileMetadata?.title;
      subtitle = `Google Document`;
      // TODO: use google doc SVG
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'GoogleDriveFileLinkMetadata':
      title = data.fileMetadata?.title;
      subtitle = `Google Drive File • ${data.fileMetadata?.extension})`;
      // TODO: use google file SVG
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'GoogleSheetsLinkMetadata':
      title = data.fileMetadata?.title;
      subtitle = `Google Sheets`;
      // TODO: use google sheets SVG
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'GoogleSlidesLinkMetadata':
      title = data.fileMetadata?.title;
      subtitle = `Google Slides`;
      // TODO: use google slides SVG
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'GenericLink':
      title = undefined;
      subtitle = `Link • ${new URL(data.url).hostname}`;
      LinkIcon = PlexFileLinkSvg;
      break;
    case 'InvalidLink':
      title = 'Broken Link';
      subtitle = '';
      // TODO: use LinkOff icon
      LinkIcon = PlexFileLinkSvg;
      break;
    default:
      assertNever(data);
  }
  return { title, subtitle, plexContentLink, LinkIcon };
};
